var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = x({ ["SEARCH_SORT_OPTIONS"]: () => __WEBPACK_EXTERNAL_MODULE__ufe_shared_constants_catalog_dfb49f35__.SEARCH_SORT_OPTIONS });